import { ButtonSize } from 'components/Button/Types'
import { useLayout } from 'stores/LayoutStore'
import { observer } from 'mobx-react-lite'
import { RightRail } from 'blaze-ui/icons'
import { Button } from './Button'

interface Props {
  size?: ButtonSize
  onPress?: (isLocked: boolean) => void
}

export const RightColumnLockButton = observer(({ size = 'md', onPress }: Props) => {
  const layout = useLayout()

  return (
    <Button
      data-testid="unlock-right-rail-button"
      onPress={() => {
        const locked = !layout.rightColumnLocked
        onPress?.(locked)
        layout.setRightColumnLocked(locked)
      }}
      aria-label={layout.rightColumnLocked ? 'Close' : 'Open'}
      icon={RightRail}
    />
  )
})
